angular.module('unergie.main')
.directive('recursive', ($compile) => {
    return {
        restrict: 'EACM',
        priority: 100000,
        compile(tElement, tAttr) {
            const contents = tElement.contents().remove()
            let compiledContents
            return function (scope, iElement, iAttr) {
                if (!compiledContents) {
                    compiledContents = $compile(contents)
                }
                iElement.append(compiledContents(scope, (clone) => clone))
            }
        },
    }
})
